import { Navigate } from 'react-router-dom';
import type { ReactElement } from 'react';

import { useFeatureFlags } from '@/hooks/useFeatureFlags';
import { FeatureFlagsOptions } from '@/hooks/useFeatureFlags/types';

export const CentralAtividadesGate = ({ children }: { children: ReactElement }) => {
  const { featureFlags, loading } = useFeatureFlags();
  if (loading) return null;
  // Em local força liberar pra facilitar testes do piloto.
  const isLocalHost = typeof window !== 'undefined'
    && ['localhost', '127.0.0.1'].includes(window.location.hostname);
  const enabled = isLocalHost || featureFlags[FeatureFlagsOptions.FF_CENTRAL_ATIVIDADES_SPN];
  if (!enabled) {
    return <Navigate to="/home" replace />;
  }
  return children;
};
